import type React from "react";
import {SimpleEnvWrapper} from "~/jobs/wrapper/SimpleEnvWrapper";
import {PaymentTermsV2Page} from "~/experiments/pages/payment-terms-v2/PaymentTermsV2Page";

/** Databag-loading wrapper for the Payment Terms v2 module; the tabs render inside the page. */
export const PaymentTermsV2Layout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true}}>
        <PaymentTermsV2Page/>
    </SimpleEnvWrapper>
);
